import { ReactNode } from 'react';
import {
  ActivityFeed,
  ActivityFeedChange,
} from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';

export function getCustomClientFieldMessage(
  change: ActivityFeedChange,
  activity: ActivityFeed,
): ReactNode {
  const actorName = activity.actor?.name?.trim() || '<Platform User>';

  switch (change.field) {
    case 'deletedAt': {
      const isRestored = change.previousValue !== null && change.value === null;
      if (isRestored) {
        return `${actorName} restored the client`;
      }
      return null;
    }
    default:
      return null;
  }
}
